import { Swiper, Navigation, Keyboard, A11y, Pagination } from 'swiper';

const pullQuoteSections = document.querySelectorAll(".adm-section-c36-pull-quote");

for (const [index, pullQuoteSection] of pullQuoteSections.entries()) {
    const c36Cards = pullQuoteSection.querySelectorAll(".adm-div-c36-pull-quote-background");
    const c36DesktopLeftArrow = pullQuoteSection.querySelector(".adm-left-arrow");
    const c36DesktopRightArrow = pullQuoteSection.querySelector(".adm-right-arrow");
    const sectionCountClassName = `c36-count-${index + 1}`;
    pullQuoteSection.classList.add(sectionCountClassName);

    const swiperc36 = new Swiper(pullQuoteSection.querySelector(".swiper"), {
        modules: [Navigation, Keyboard, A11y, Pagination],
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 1,
        centeredSlides: true,
        speed: 1500,
        navigation: {
            nextEl: `.${sectionCountClassName} .adm-swiper-right-arrow`,
            prevEl: `.${sectionCountClassName} .adm-swiper-left-arrow`,
            disabledClass: "adm-arrow-disabled",
        },
        a11y: false,
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
        pagination: {
            el: `.${sectionCountClassName} .adm-div-c36-slider-pagination`,
            type: "fraction",
            formatFractionCurrent: function (number) {
                return number.toString().padStart(2, '0')
            },
            formatFractionTotal: function (number) {
                return number.toString().padStart(2, '0')
            }
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
        }
    });

    let currentC36Viewport = "";
    function resizeComponent() {
        let maxHeight = 0;
        
        switch (true) {
            case (window.screen.width < 767 && currentC36Viewport !== "mobile"):
                currentC36Viewport = "mobile";
                c36Cards.forEach(card => {
                    card.style.height = "unset";
                    setTimeout(() => {
                        let elHeight = card.clientHeight;
                        if (elHeight > maxHeight) maxHeight = elHeight;
                    }, 0);
                });
                setTimeout(() => {
                    c36Cards.forEach(card => {
                        card.style.height = `${maxHeight}px`;
                    });
                }, 0);
                break;
            case (window.innerWidth >= 767 && currentC36Viewport !== "desktop"):
                currentC36Viewport = "desktop";
                c36Cards.forEach(card => {
                    card.style.height = "unset";
                });
                setTimeout(() => positionDesktopArrows(), 0);
                break;
        }
    }
    resizeComponent();
    window.addEventListener('resize', resizeComponent);

    const arrowButtonsPullQuote = pullQuoteSection.querySelectorAll(".adm-button-c36-pull-quote");

    function disableArrowButtonsPullQuote() {
        if (arrowButtonsPullQuote) {
            [].forEach.call(arrowButtonsPullQuote, (arrowButton) => {
                arrowButton.tabIndex = -1;
            });
        }
    }

    disableArrowButtonsPullQuote();

    function positionDesktopArrows() {
        const c36SlideHeight = pullQuoteSection.querySelector(".swiper-slide-active .adm-div-c36-pull-quote-background")?.clientHeight;
        const desktopArrowPosition = c36SlideHeight / 2 - 30;
        if (c36DesktopLeftArrow) c36DesktopLeftArrow.style.transform = "translateY(" + desktopArrowPosition + "px)";
        if (c36DesktopRightArrow) c36DesktopRightArrow.style.transform = "translateY(" + desktopArrowPosition + "px)";
    }

    if (swiperc36.pagination.bullets) {
        swiperc36.pagination.bullets.forEach(bullet => bullet.tabIndex = -1);
        swiperc36.on("realIndexChange", () => {
            swiperc36.pagination.bullets.forEach(bullet => bullet.tabIndex = -1);
        });

        swiperc36.on("slideChangeTransitionStart", positionDesktopArrows);
    }

    swiperc36.slides.forEach((slide, slideIndex) => {
        slide.addEventListener("keydown", (event) => {

            const pressedKeyCode = event.which || event.keyCode;
            if (!event.shiftKey && pressedKeyCode == 9) {
                if (slideIndex + 1 < swiperc36.slides.length) {
                    event.preventDefault();
                    swiperc36.slideNext(1500);
                    setTimeout(() => {
                        swiperc36.slides[swiperc36.activeIndex].focus()
                    }, 300)
                }
                disableArrowButtonsPullQuote();
            } else if (event.shiftKey && pressedKeyCode == 9) {
                swiperc36.slidePrev(1500);
                disableArrowButtonsPullQuote();
            }
        })
    })
    positionDesktopArrows();
}